import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import Page from '../../common-components/Page';
import DownloadData from './DownloadData';
import DownloadReport from './DownloadReport';
import DownloadConfig from './DownloadConfig';
import DownloadReportTypeMenu from './DownloadReportTypeMenu';
import Tabs from '../../common-components/Tabs';

class DownloadScreen extends Component {
  state = { selectedReportType: 'monthly' };

  render() {
    const { t } = this.props;
    const { selectedReportType } = this.state;
    return (
      <Page title={t('download')}>
        <Tabs tabClassNames={['', 'downloadReportParentTab', '']}>
          <div label={t('download-data')}>
            <DownloadData />
          </div>
          <div
            label={(
              <DownloadReportTypeMenu
                selectedReportType={selectedReportType}
                onSelect={reportType => this.setState({ selectedReportType: reportType })}
              />
            )}
          >
            <DownloadReport reportType={selectedReportType} />
          </div>
          <div label={t('download-configuration')}>
            <DownloadConfig />
          </div>
        </Tabs>
      </Page>
    );
  }
}

export default withTranslation()(DownloadScreen);
